function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SignatureCanvas from "react-signature-canvas";
import { Space, Button, Image, Modal, notification } from "antd";
import ReactDOM from "react-dom";
import { CheckCircleFill, XCircle } from "react-bootstrap-icons";
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var SignaturePadNoVaccin = function SignaturePadNoVaccin(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler,
    form_type = _ref.form_type,
    s_im = _ref.s_im;
  var _useState = useState(candidat.medecine_questions != null ? candidat.medecine_questions.signaturenv : null),
    _useState2 = _slicedToArray(_useState, 2),
    signatureImage = _useState2[0],
    setSignatureImage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var signatureCanvasRef = useRef(null);
  var clearSignature = function clearSignature() {
    signatureCanvasRef.current.clear();
    setSignatureImage("");
  };
  var saveSignature = function saveSignature() {
    setSignatureImage(signatureCanvasRef.current.getTrimmedCanvas().toDataURL('image/png'));
  };
  var sendSignature = function sendSignature() {
    if (signatureImage == "" || signatureImage == null) {
      notification.error({
        message: "Erreur",
        description: "Singature introuvable"
      });
      return;
    }
    setIsDataLoading(true);
    confirm({
      title: "Confirmez-vous ?",
      content: "L'enregistrement de la signature pour le condidat " + candidat.name,
      onOk: function onOk() {
        var fd = new FormData();
        fd.append("user_id", Common.currentUser.id);
        fd.append("customer_id", candidat.id.toString());
        fd.append("signature", signatureImage);
        fd.append("form_type", form_type);
        axios.post(Common.baseApiUrl + "setchecksignaturenv", fd).then(function (response) {
          if (response.data.status == 200) {
            handler();
            s_im(signatureImage);
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Ok!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {
          setIsDataLoading(false);
        });
      },
      onCancel: function onCancel() {
        setIsDataLoading(false);
      }
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 8,
          style: {
            background: "#E7E1D0",
            padding: "10px",
            borderRadius: "5px"
          },
          children: [/*#__PURE__*/_jsx(SignatureCanvas, {
            penColor: "#585650",
            ref: signatureCanvasRef,
            canvasProps: {
              width: 500,
              height: 300,
              className: "sigCanvas"
            }
          }), /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Button, {
                type: "primary",
                icon: /*#__PURE__*/_jsx(CheckCircleFill, {}),
                onClick: saveSignature,
                children: /*#__PURE__*/_jsx("b", {
                  children: "ENREGISTRER"
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "default",
                icon: /*#__PURE__*/_jsx(XCircle, {}),
                onClick: clearSignature,
                children: /*#__PURE__*/_jsx("b", {
                  children: "REPRENDRE"
                })
              })]
            })
          })]
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
              padding: "8px"
            },
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "vertical",
              children: [/*#__PURE__*/_jsx(Image, {
                src: signatureImage,
                width: "150px"
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Button, {
                loading: isDataLoading,
                type: "primary",
                icon: /*#__PURE__*/_jsx(CheckCircleFill, {}),
                onClick: sendSignature,
                children: /*#__PURE__*/_jsx("b", {
                  children: "CONFIRMER"
                })
              })]
            })
          })
        })]
      })
    })
  });
};
export default SignaturePadNoVaccin;